import { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";

import { DashGridL2 } from "layouts/dash-grid";

import Main from "./Main";
import { fetchOfficersList } from "slices/officers";
import LeadsContext from "./leads.context";

const Top = () => <div />;

const Leads = () => {
  const dispatch = useDispatch();
  const { loading, user } = useSelector((state) => state.user);
  const { officers } = useSelector((state) => state.officers);

  const [officer, setOfficer] = useState({});
  const [planDate, setPlanDate] = useState();
  const [plan, setPlan] = useState({});

  useEffect(() => {
    if (!user?._id) return;

    dispatch(fetchOfficersList(user.SAP_ID));
  }, [user]);

  const value = { officer, planDate, plan, setOfficer, setPlanDate, setPlan };

  return (
    <LeadsContext.Provider value={value}>
      <DashGridL2 Top={Top} Main={Main} />
    </LeadsContext.Provider>
  );
};

export default Leads;
